export const sidebarDataAdmin = [
  {
    userId: "tenderlist",
    subMenu: null,
    name: "Tender List",
  },
  {
    userId: "dashboard",
    name: "Dashboard",
  },
  {
    userId: "tenderscrapper",
    subMenu: null,
    name: "Tender Scrapper",
  },
  {
    userId: "trashtender",
    name: "Trashed Tender",
  },
  {
    userId: "customersrequested",
    name: "Customer Requested Tenders",
  },

  {
    userId: "contactusdata",
    name: "Queries",
  },
  {
    userId: "demoenquiries",
    name: "Demo Enquiries",
  },
  {
    userId: "allusers",
    name: "All Users",
  },
  {
    userId: "coupons",
    name: "Coupons",
  },
  {
    userId: "homepageshowcase",
    name: "Homepage showcase",
  },
];

export const sidebarData = sidebarDataAdmin;
